// extracted by mini-css-extract-plugin
export default {"block":"Structure_block__1GBEI","cards":"Structure_cards__gHlf1","content":"Structure_content__fJHtp"};